<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 05/02/2019 12:59AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>NEW: Added situation drop down.</li>
            <li>NEW: Stacked Offensive Neutral Defensive chart.</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="turnovers"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   
    <section id="players">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Turnovers" heading="Turnovers" v-bind:headers="TurnoverPlayerHeadings" v-bind:tableData="sortByTurnoverData">
          <template slot="filter">
          <div class="columns">
            <div class="column">
              <label class="label">Sort</label>
              <div class="control">
                <div class="select">
                  <select v-model="FilterSelected"  @change="sortByTurnoverDataChart">
                    <option v-for="option in TurnoverPlayerFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <label class="label">Situation</label>
              <div class="control">
                <div class="select">
                <select v-model="SituationSelected"  @change="fetchSeasonStats">
                    <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value" v-on:change="fetchSeasonStats()">{{option.text}}</option>
                </select>
                </div>
              </div>
            </div>
          </div>
          </template>
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="chartStackedData" :options="bar_options" style=""></chart>
          </div>
        </data-table>
      </div>
    </section>
<section id="rolling">
       <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Rolling" heading="Rolling Turnover Data">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
              <div class="column">
                <label class="label">Sample Size</label>
                <div class="control">
                  <input type="number" class="input" min="5" max="30" step="1" v-model="RollingLimit" v-on:change="fetchGraphStats()">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildRollingChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
<section id="cumulative">
       <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Hits" heading="Cumulative Turnover Data">
          <template  slot="filter">
            <div>
              <label class="label">Player(s)</label>
              <multiselect v-model="PlayerSelected" :options="PlayerOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="PlayerSelected.length &amp;&amp; !isOpen">{{ PlayerSelected.length }} options selected</span></template>
              </multiselect>
            <!--<pre class="language-json"><code>{{ PlayerSelected  }}</code></pre>-->
            </div>
            <label class="label">Data Selection</label>
            <div class="control">
              <div class="select">
                <select v-model="GameByGameDataSelected">
                  <option v-for="option in GameByGameDataOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            <h1 class="label">Graph Options</h1>
            <div class="columns">
              <div class="column">
                <label class="label">Fill</label>
                <div class="control">
                  <input type="checkbox" class="checkbox" v-model="GameByGameFill">
                </div>
              </div>
              <div class="column">
                <label class="label">Line Tension</label>
                <div class="control">
                  <input type="number" class="input" min="0.0" max="1" step="0.1" v-model="GameByGameTension">
                </div>
              </div>
            </div>
          </template>
          <div slot="graph">
              <chart :type="'line'" :data="buildCumulativeChartData" :options="line_options" style=""></chart>
          </div>
        </data-table>
       </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    Chart,
    Multiselect
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      PlayerSelected: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'to_total',
      TurnoverPlayerData: [],
      RollingTurnoverData: [],
      CumulativeTurnoverData: [],
      GameByGameFill: false,
      GameByGameTension: 0,
      RollingLimit: 5,
      FilterHeadings: [],
      GameByGameDataSelected: 'to_total',
      GameByGameDataOptions: [
        {text: 'Offensive', value: 'to_offensive'},
        {text: 'Neutral', value: 'to_neutral'},
        {text: 'Defensive', value: 'to_defensive'},
        {text: 'Total', value: 'to_total'}
      ],
      TurnoverPlayerHeadings: [
        'Player',
        'GP',
        'Offensive',
        'Offensive AVG',
        'Neutral',
        'Neutral AVG',
        'Defensive',
        'Defensive AVG',
        'Total',
        'Average / Game'
      ],
      TurnoverPlayerFilters: [
        {text: 'Stacked Totals', value: 'stacked_totals'},
        {text: 'Stacked Avg', value: 'stacked_avg'},
        {text: 'Offensive', value: 'to_offensive'},
        {text: 'Offensive AVG', value: 'to_offensive_avg'},
        {text: 'Neutral', value: 'to_neutral'},
        {text: 'Neutral AVG', value: 'to_neutral_avg'},
        {text: 'Defensive', value: 'to_defensive'},
        {text: 'Defensive AVG', value: 'to_defensive_avg'},
        {text: 'Total', value: 'to_total'},
        {text: 'Average / Game', value: 'to_average'}
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              reverse: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    sortByTurnoverData: function () {
      if (this.FilterSelected === 'stacked_totals' || this.FilterSelected === 'stacked_avg') {
        return _.orderBy(this.TurnoverPlayerData, 'to_total', ['desc'])
      }
      return _.orderBy(this.TurnoverPlayerData, this.FilterSelected, ['desc'])
    },
    sortByTurnoverDataChart: function () {
      let orderedData = this.sortByTurnoverData
      return _.map(orderedData, this.FilterSelected)
    },
    chartStackedData: function () {
      let playerLabels = []
      for (var label of this.sortByTurnoverData) {
        playerLabels.push(label.player)
      }
      let offensive = []
      let neutral = []
      let defensive = []
      for (var d of this.sortByTurnoverData) {
        if (this.FilterSelected === 'stacked_avg') {
          offensive.push(d.to_offensive_avg)
          neutral.push(d.to_neutral_avg)
          defensive.push(d.to_defensive_avg)
        } else {
          offensive.push(d.to_offensive)
          neutral.push(d.to_neutral)
          defensive.push(d.to_defensive)
        }
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: offensive,
        label: 'Offensive',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf'
      },
      {
        data: neutral,
        label: 'Neutral',
        backgroundColor: '#ff9677',
        borderColor: '#ff9677'
      },
      {
        data: defensive,
        label: 'Defensive',
        backgroundColor: '#7263bb',
        borderColor: '#7263bb'
      }]
      return data
    },
    buildRollingChartData: function () {
      let matchLabels = []
      let customData = []
      for (var label of this.RollingTurnoverData) {
        matchLabels.push(label.formatted_date)
      }
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
        // console.log(colour)
        customData.push({data: this.buildRollingData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      // console.log(data)
      return data
    },
    buildCumulativeChartData: function () {
      let matchLabels = []
      let customData = []
      for (var label of this.CumulativeTurnoverData) {
        matchLabels.push(label.formatted_date)
      }
      for (var player of this.PlayerSelected) {
        var colour = Math.floor(Math.random() * 16777215).toString(16)
        // console.log(colour)
        customData.push({data: this.buildCumulativeData(player.name), label: player.name[0] + player.name[1], borderColor: '#' + colour, backgroundColor: '#' + colour, fill: this.GameByGameFill, lineTension: this.GameByGameTension})
      }
      let data = {
        labels: matchLabels,
        datasets: customData
      }
      // console.log(data)
      return data
    }
  },
  methods: {
    buildRollingData (_name) {
      let results = []
      for (var game of this.RollingTurnoverData) {
        // console.log('Searching:' + JSON.stringify(game))
        for (var v of game.player_data) {
          if (v.player === _name) {
            // console.log('Found Player: ' + v.player)
            switch (this.GameByGameDataSelected) {
              case 'to_offensive':
                results.push(v.to_offensive)
                break
              case 'to_neutral':
                results.push(v.to_neutral)
                break
              case 'to_defensive':
                results.push(v.to_defensive)
                break
              case 'to_total':
                results.push(v.to_total)
                break
            }
          }
        }
      }
      return results
    },
    buildCumulativeData (_name) {
      let results = []
      for (var game of this.CumulativeTurnoverData) {
        // console.log('Searching:' + JSON.stringify(game))
        for (var v of game.player_data) {
          if (v.player === _name) {
            // console.log('Found Player: ' + v.player)
            switch (this.GameByGameDataSelected) {
              case 'to_offensive':
                results.push(v.to_offensive)
                break
              case 'to_neutral':
                results.push(v.to_neutral)
                break
              case 'to_defensive':
                results.push(v.to_defensive)
                break
              case 'to_total':
                results.push(v.to_total)
                break
            }
          }
        }
      }
      return results
    },
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.TurnoverPlayerData = response.data.turnovers
          },
          response => {}
        )
    },
    fetchSeasonRollingStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected,
        'rolling_limit': this.RollingLimit
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers-rolling', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.RollingTurnoverData = response.data.rolling_games
          },
          response => {}
        )
    },
    fetchSeasonCumulativeStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/turnovers-cumulative', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.CumulativeTurnoverData = response.data.rolling_games
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let player = response.data.cardiff_players
            this.PlayerOptions.push({name: 'All', id: 0})
            for (var p = 0; p < player.length; p++) {
              this.PlayerOptions.push({name: player[p].number + ' ' + player[p].surname, id: player[p].id})
            }
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: 1})
            this.SituationOptions.push({text: 'Power Play', value: 2})
            this.SituationOptions.push({text: 'Short Handed', value: 3})
            this.SituationOptions.push({text: 'Empty Net', value: 4})
            this.SituationOptions.push({text: '--Not avalible yet - Secondary Situations--', value: -5})

            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
    this.fetchSeasonRollingStats()
    this.fetchSeasonCumulativeStats()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// turnovers.vue?3e83d3b0